"use strict";exports.circumference=function(e){return Math.PI*e*2};
//# sourceMappingURL=circumference.cjs.map
